import { Divider, Heading, HStack, Text, Box, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';
import { SaneImage } from '@components/sanity/sane-image';
import Link from 'next/link';
import { Post } from './listing';

interface BlogPostCardProps {
  post: Post;
}

export function BlogPostCard({ post }: BlogPostCardProps): JSX.Element {
  const formattedDate =
    post.date && format(new Date(post.date), 'MMM dd, yyyy');

  return (
    <VStack
      borderRadius="12px"
      bg="white"
      shadow="xl"
      overflow={'hidden'}
      maxW="580px"
    >
      <Link legacyBehavior href={post.slug} passHref>
        <VStack as="a" h={{ lg: '580px' }} color="gray.900">
          <Box>
            {post.coverImage && (
              <SaneImage alt={post.title} src={post.coverImage} />
            )}

            {/* {!post.live && (
              <Box className="absolute top-0 left-0 flex justify-center w-full py-1 font-medium text-white uppercase bg-green-500">
                Preview
              </Box>
            )} */}
          </Box>

          <Box
            display={'flex'}
            flexDir={'column'}
            justifyContent="space-between"
            p="24px"
            bg="white"
            gap="24px"
            h="full"
            pos="relative"
          >
            <Heading
              as="h4"
              size="sm"
              color="primary.500"
              mb={{ base: '8px', lg: 0 }}
              bg="primary.25"
              maxW="fit-content"
              padding="6px 12px"
              gap="8px"
              borderRadius={'999px'}
            >
              {post.category}
            </Heading>

            <Box h="100%" display={'flex'} flexDir="column" gap="24px">
              <Heading size="h6">{post.title}</Heading>
              <Text lineHeight="28px" color="gray.900">
                {post.excerpt}
              </Text>
            </Box>

            <HStack pos="relative">
              {' '}
              <SaneImage
                className="block h-10 w-10 rounded-full"
                alt={post.author.name}
                src={post.author.picture}
                height={40}
                width={40}
                quality={100}
              />
              <Text pl="16px" pr="12px">
                {post.author.name}
              </Text>
              <Divider h="28px" orientation="vertical" />
              <Text pl="12px">{formattedDate}</Text>
            </HStack>
          </Box>
        </VStack>
      </Link>
    </VStack>
  );
}
